import styled from 'styled-components';

import { ColorPalette } from '../../App/global.styles';

export const AboutPageContainer = styled.div`
	align-items: center;
	padding: 20px 0;
	margin-bottom: 4rem;

	@media screen and (max-width: 800px) {
		margin-bottom: 1rem;
	}
`;

export const JumbotronContainer = styled.div`
	width: 100%;
	display: grid;
	align-items: center;
	padding: 20px;
	grid-gap: 2em;
	grid-template-areas: 'leftItem rightItem rightItem';

	@media screen and (max-width: 1400px) {
		grid-gap: 3em;
		padding: 0 300px;
		grid-template-areas: 'rightItem ' 'leftItem';
	}

	@media screen and (max-width: 1000px) {
		padding: 0 200px;
	}

	@media screen and (max-width: 800px) {
		padding: 0 20px;
	}
`;

export const JumbotronLeftItem = styled.div`
	grid-area: leftItem;
	align-items: center;
`;

export const JumbotronRightItem = styled.div`
	grid-area: rightItem;
	align-items: center;
	display: flex;
	justify-content: center;
`;

export const JumbotronHeading = styled.h1`
	font-size: 3.5rem;
	font-weight: bold;
	text-align: center;

	@media screen and (max-width: 1400px) {
		text-align: center;
	}

	@media screen and (max-width: 1000px) {
		font-size: 2.5rem;
	}
`;

export const JumbotronParagraph = styled.div`
	align-self: center;
	color: ${ColorPalette.paragraph};
	font-size: 1.3rem;
	font-weight: 400;
	text-align: left;
	margin: 0;
	&:first-child {
		margin-top: 0;
	}

	@media screen and (max-width: 1400px) {
		text-align: center;
	}

	@media screen and (max-width: 1000px) {
		font-size: 1.1rem;
		padding-top: unset;
	}
`;

export const ResumeLinkButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	@media screen and (max-width: 1400px) {
		align-items: center;
		justify-content: center;
	}
`;

export const ResumeLinkButton = styled.div`
	margin-top: 1.5rem;
	background-color: ${ColorPalette.button};
	color: ${ColorPalette.buttonText};
	display: inline-block;
	margin-right: 0.6rem;
	margin-bottom: 0.6rem;
	padding: 10px 15px;
	border-radius: 3px;
	font-size: 1rem;
	font-weight: 700;
`;
